import styled from 'styled-components';

import { media } from '@/shared/components';
import { Drawer } from '@/shared/components/drawer';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Body = styled.div`
  padding: 24px 24px 0 24px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-height: calc(100% - 92px);
  height: 100%;
`;

export const Item = styled.label`
  display: flex;
  gap: 8px;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid ${COLORS.systemDark100};
  align-items: flex-start;
  cursor: pointer;

  &.active {
    border: 1px solid ${COLORS.systemSky300};
  }
`;

export const ItemTitle = styled.b`
  font-size: 16px;
  line-height: 24px;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  color: ${COLORS.systemDark300};
`;

export const SubTitle = styled.b`
  font-size: 12px;
  line-height: 16px;
`;

export const List = styled.ul`
  list-style-position: inside;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background: ${COLORS.systemDark50A};
  flex-shrink: 0;
`;
export const ItemTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const CollapsibleWrapper = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.25s ease;

  &.active {
    padding-top: 12px;
    grid-template-rows: 1fr;
  }
`;

export const CollapsibleInner = styled.div`
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &.active {
    overflow: visible;
  }
`;

export const IconStyled = styled(Icon)`
  transition: transform 0.25s ease;
  display: block;

  &.active {
    transform: scale(1, -1);
  }
`;

export const Footer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: flex-end;
  padding: 24px;

  ${media.sm} {
    flex-direction: column-reverse;
    padding: 16px;
  }
`;

export const MembersSelect = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  border-radius: 12px;
  background: ${COLORS.systemLight200};

  ${media.sm} {
    margin-left: -32px;
  }
`;

export const RadioWrapper = styled.div`
  margin-top: 8px;
`;

export const RadioItem = styled.label`
  display: flex;
  gap: 4px;
  padding: 4px 0;
  align-items: flex-start;
  cursor: pointer;
`;
